import { privateApi } from "../api/axios";


export const getTextDirection = async () => {
    try {
        const response = await privateApi.get("api/ownerdatas/newssentence");
        return response;
    } catch (error) {
        throw error;
    }
} 

export const postTextDirection = async (text: string) => {
    try {
        const response = await privateApi.post("api/ownerdatas/newssentence", { newsSentence : text });
        return response;
    } catch (error) {
        throw error;
    }
}